import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { textLinkStyles } from 'components/TextLink';
import { visuallyHidden } from 'styles/mixins';
var FileInput = styled.input.attrs({
  type: 'file'
}).withConfig({
  displayName: "FileInputLink__FileInput",
  componentId: "sc-1cq6kfc-0"
})(["", ""], visuallyHidden);
var TextLinkLabel = styled.label.withConfig({
  displayName: "FileInputLink__TextLinkLabel",
  componentId: "sc-1cq6kfc-1"
})(["", " cursor:pointer;input:focus + &{outline:3px solid currentColor;outline-offset:3px;text-decoration:underline;}"], textLinkStyles);
var FileInputLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileInput, _extends({
    ref: ref,
    id: id
  }, otherProps)), /*#__PURE__*/React.createElement(TextLinkLabel, {
    htmlFor: id
  }, children));
});
FileInputLink.displayName = 'FileInputLink';
export default FileInputLink;